/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, ReactNode } from 'react';
import { useTheme } from '../hooks';

import { ViewMode } from '../hooks/useTheme';

interface ThemeContextType {
  isDarkMode: boolean;
  setIsDarkMode: (isDark: boolean) => void;
  toggleTheme: () => void;
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  toggleViewMode: () => void;
}


const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { isDarkMode, setIsDarkMode, toggleTheme, viewMode, setViewMode, toggleViewMode } = useTheme();

  return (
    <ThemeContext.Provider value={{ isDarkMode, setIsDarkMode, toggleTheme, viewMode, setViewMode, toggleViewMode }}>
      {children}
    </ThemeContext.Provider>
  );
};


export const useThemeContext = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within ThemeProvider');
  }
  return context;
};
